// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jFGMFRGJvL3VOh50QipNYQ\\=\\={position:relative}.YWJvrXoGpkz8ynhJ397Z9g\\=\\={position:absolute;height:50px;width:100%;display:flex;justify-content:center;align-items:center}.YWJvrXoGpkz8ynhJ397Z9g\\=\\= svg{z-index:1}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DeliveryDashboardMapMarkers/components/MapPin/MapPin.module.scss"],"names":[],"mappings":"AAAA,4BACI,iBAAA,CAGJ,4BACI,iBAAA,CACA,WAAA,CACA,UAAA,CACA,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,gCACE,SAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MapPinContainer": "jFGMFRGJvL3VOh50QipNYQ==",
	"MapPinIcon": "YWJvrXoGpkz8ynhJ397Z9g=="
};
export default ___CSS_LOADER_EXPORT___;
